module.exports = __webpack_public_path__ + "static/media/sou_empresa.d37b485f.jpeg";